import { addDays } from 'date-fns';

import { WorkloadStatus } from '../../../types';

import {
    AgentWorkloadFeedbackReminderConfigurator,
    AgentWorkloadReminder,
    AgentWorkloadReminderType,
    CollectCapacityReminderContext,
} from '../CollectCapacityReminderConfigurator';

export class OverloadedForTwoDaysConfigurator implements AgentWorkloadFeedbackReminderConfigurator {
    support(context: CollectCapacityReminderContext): boolean {
        return context.agentWorkload?.status === WorkloadStatus.Overloaded;
    }

    get(context: CollectCapacityReminderContext): AgentWorkloadReminder | null {
        if (!context.agentWorkload) {
            return null;
        }

        return {
            type: AgentWorkloadReminderType.OverloadedForTwoDays,
            remindAt: addDays(context.agentWorkload.lastUpdatedAt, 2),
        };
    }
}
